import View360 from "./View360";

export default View360;
